
document.addEventListener('DOMContentLoaded', function () {
        var articles = document.querySelectorAll('#blog-articles .blog-md-article');
var separators = document.querySelectorAll('#blog-articles .blog-md-separator');
var shown = 4;
var step = 2;
var isLoading = false;
var preload = document.getElementById('infinite-scroll-preload');

// Nascondi tutti tranne i primi 4
for (var i = shown; i < articles.length; i++) {
    articles[i].style.display = 'none';
if (separators[i]) separators[i].style.display = 'none';
        }

function showMoreArticles() {
            if (isLoading || shown >= articles.length) return;
isLoading = true;
if (preload) preload.style.display = 'block';

setTimeout(function () {
                for (var i = shown; i < shown + step && i < articles.length; i++) {
    articles[i].style.display = '';
if (separators[i]) separators[i].style.display = '';
                }
shown += step;
if (preload) preload.style.display = 'none';
isLoading = false;

                // Se dopo aver caricato ci sono ancora articoli nascosti e siamo ancora in fondo, carica ancora
                if ((window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 200) && shown < articles.length) {
    showMoreArticles();
                }
            }, 500);
        }

// Carica altri articoli quando si scrolla vicino al fondo
window.addEventListener('scroll', function () {
            if ((window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 200)) {
    showMoreArticles();
            }
        });

        // Se la pagina è già troppo corta, carica subito altri articoli
        if ((window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 200)) {
    showMoreArticles();
        }
    });